import { WidgetType } from 'domain/entity/widget';
import WidgetData, { ColorType, WidgetDataAvailability, WidgetDescription } from 'domain/entity/widgetData';

export enum TableCellType {
    TEXT = 'TEXT',
    NUMERIC = 'NUMERIC',
    DATE = 'DATE',
    TAG = 'TAG',
    ICON = 'ICON',
    GRID = 'GRID',
    ROW = 'ROW',
    GRID_CELL = 'GRID_CELL',
    ERROR = 'ERROR',
    EMPTY = 'EMPTY',
}
// FIRST LEVEL TYPES
export type TableColumn = {
    headerTitle: string;
    fixed: boolean | null;
    cells: SortableTableCell[];
    footer: TableFooter | null;
    widthProportion: number;
    isSortable: boolean;
};

export type SortableTableCell = {
    sortValue: number;
    content: OneOfAllSimpleContent | Grid;
};

export type TableFooter = {
    content: OneOfAllSimpleContent | Grid;
};

// FUNDAMENTAL ELEMENTS
export type SimpleTableCell = {
    content: OneOfAllSimpleContent;
};

export type Grid = {
    type: TableCellType.GRID;
    children: Row[];
};

export type Row = {
    type: TableCellType.ROW;
    children: (Row | GridCell | Grid)[];
};

export type TagCell = {
    type: TableCellType.TAG;
    content: OneOfAllSimpleContentMinusTag;
    tagBackgroundColorType: ColorType | null;
    tagBackgroundColorDefault: string | null;
    tagIcon: string | null;
    tagType: string | null;
} & CommonContent;
export type GridCell = {
    type: TableCellType.GRID_CELL;
    content: OneOfAllSimpleContent | Grid;
    xs: number | null;
    sm: number | null;
    md: number | null;
    lg: number | null;
    xsOffset: number | null;
    smOffset: number | null;
    mdOffset: number | null;
    lgOffset: number | null;
};

// CELL CONTENTS

export type CommonContent = {
    backgroundColorType: ColorType | null;
    backgroundColorDefault: string | null;
    align: string | null;
};

export type TextContent = {
    type: TableCellType.TEXT;
    value: string | null;
    fontColorType: ColorType | null;
    fontColorDefault: string | null;
    fontWeight: number | null;
    tooltip: string | null;
} & CommonContent;

export type DateContent = {
    type: TableCellType.DATE;
    value: Date | null;
    fontColorType: ColorType | null;
    fontColorDefault: string | null;
    fontWeight: number | null;
    tooltip: string | null;
} & CommonContent;

export type NumericContent = {
    type: TableCellType.NUMERIC;
    units: string;
    value: number | null;
    showSignedValue: boolean;
    fontColorType: ColorType | null;
    fontColorDefault: string | null;
    fontWeight: number | null;
    tooltip: string | null;
} & CommonContent;

export type IconContent = {
    type: TableCellType.ICON;
    value: string | null;
    iconColorType: ColorType | null;
    iconColorDefault: string | null;
    tooltip: string | null;
} & CommonContent;

// SUMMARIES

export type OneOfAllSimpleContent = TextContent | IconContent | NumericContent | DateContent | TagCell;
export type OneOfAllSimpleContentMinusTag = TextContent | IconContent | NumericContent | DateContent;

export type TableWidgetData = WidgetData & { columns: TableColumn[] };

class TableData implements TableWidgetData {
    type = WidgetType.TABLE;

    constructor(
        readonly dataAvailability: WidgetDataAvailability,
        readonly description: WidgetDescription,
        readonly columns: TableColumn[]
    ) {}
}

export default TableData;
